export const AUDIO_CALL_STATUS = Object.freeze({
  VOICEMAIL: "VOICEMAIL",
  NORMAL: "NORMAL",
  MISSED: "MISSED",
});
